import { Link } from "react-router-dom";
import { Sun, ArrowUpRight, Calendar } from "lucide-react";
import { SUMMER_DESTINATIONS } from "@/data/content";
import { resolveAssetPath } from "@/lib/assets";

export const SummerDestinations = () => {
  return (
    <section
      id="summer"
      data-testid="summer-section"
      className="relative bg-gradient-to-b from-[#fff8e7] via-white to-white py-16 overflow-hidden"
    >
      {/* Sun ornament */}
      <div className="absolute -top-32 right-0 w-[480px] h-[480px] rounded-full bg-gradient-to-br from-[#fcd34d]/30 to-transparent blur-3xl pointer-events-none" />

      <div className="relative max-w-[1280px] mx-auto px-4 lg:px-6">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-[var(--red)] font-semibold text-[11px] tracking-[0.3em] mb-3">
              <Sun className="w-4 h-4 text-[var(--yellow-2)]" />
              SEASONAL · SUMMER 2026
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl text-[var(--navy)] leading-tight">
              Summer <span className="text-[var(--yellow-2)]">getaways</span>
              <br className="hidden md:block" />
              we are loving.
            </h2>
          </div>
          <a
            href="#destinations"
            data-testid="summer-view-all"
            className="text-sm text-[var(--navy)] hover:text-[var(--yellow-2)] font-medium inline-flex items-center gap-2 group"
          >
            See all summer tours
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SUMMER_DESTINATIONS.map((d, i) => (
            <Link
              to={`/search?q=${encodeURIComponent(d.name.replace(/·/g, " "))}`}
              key={d.name}
              data-testid={`summer-card-${i}`}
              className="group relative overflow-hidden rounded-2xl bg-white border border-gray-200 hover:border-[#f59e0b]/50 shadow-sm hover:shadow-2xl transition-all duration-500"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={resolveAssetPath(d.image)}
                  alt={d.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-[var(--yellow)] text-[var(--navy)] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                  <Calendar className="w-3 h-3" />
                  {d.months}
                </span>
                <div className="absolute bottom-3 left-3 right-3 text-white">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--yellow)]">
                    {d.country}
                  </div>
                  <div className="font-serif-display text-2xl leading-tight">
                    {d.name}
                  </div>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-gray-600 leading-relaxed">
                  {d.blurb}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <div>
                    <div className="text-[10px] uppercase tracking-widest text-gray-400">
                      Starting at
                    </div>
                    <div className="font-serif-display text-xl text-[var(--navy)]">
                      {d.price}
                    </div>
                  </div>
                  <span className="w-9 h-9 rounded-full bg-[var(--navy)] group-hover:bg-[var(--yellow)] flex items-center justify-center transition-colors">
                    <ArrowUpRight className="w-4 h-4 text-white group-hover:text-[var(--navy)]" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
